export default {
      id: "ic_home-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_home-usage",
      toString: function () {
        return this.url;
      }
    }